<template>
  <div class="tablist">
    <div
      :class="[{ active: activeName == item.name }]"
      v-for="item in buyNjList"
      :key="item.id"
      @click="rangeClick(item)"
    >
      <img :src="item.img" alt="" />
      <span>{{ item.name }}</span>
    </div>
    <p style="font-size: 0.8vw;">当前时间：{{ realTime }}</p>
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {},
  data() {
    return {
      buyNjList: [
        {
          id: 1,
          name: "农机分布",
          img: "../../../../static/img/data_njfb.png"
        },
        {
          id: 2,
          name: "减排统计",
          img: "../../../../static/img/data_zytj.png"
        }
      ],
      activeName: "",
      realTime: ""
    };
  },
  mounted() {
    // 加载当前日期
    this.realTime = this.dealWithTime(new Date());
    const _this = this;
    this.timer = setInterval(function() {
      _this.realTime = _this.dealWithTime(new Date()); // 修改数据date
    }, 1000);
    if (window.location.pathname === "/view/MachineryStock") {
      this.activeName = "农机分布";
      this.$set(this.buyNjList[0], "img", "/static/img/data_njfb0.png");
      this.$set(this.buyNjList[1], "img", "/static/img/data_zytj.png");
    } else if (
      window.location.pathname === "/view/TimeDistribution" || window.location.pathname === "/view/ToolDistribution"
    ) {
      this.activeName = "减排统计";
      this.$set(this.buyNjList[0], "img", "/static/img/data_njfb.png");
      this.$set(this.buyNjList[1], "img", "/static/img/data_zytj0.png");
    }
  },
  methods: {
    rangeClick(item) {
      if (item.id === 1) {
        this.$router.push("/MachineryStock");
      } else if (item.id === 2) {
        this.$router.push("/MachineTar");
      }
    },
    // 获取日期
    dealWithTime(data) {
      let formatDateTime;
      const Y = data.getFullYear();
      const M = data.getMonth() + 1;
      const D = data.getDate();
      let H = data.getHours();
      let Min = data.getMinutes();
      let S = data.getSeconds();
      let W = data.getDay();
      H = H < 10 ? "0" + H : H;
      Min = Min < 10 ? "0" + Min : Min;
      S = S < 10 ? "0" + S : S;
      switch (W) {
        case 0:
          W = "天";
          break;
        case 1:
          W = "一";
          break;
        case 2:
          W = "二";
          break;
        case 3:
          W = "三";
          break;
        case 4:
          W = "四";
          break;
        case 5:
          W = "五";
          break;
        case 6:
          W = "六";
          break;
        default:
          break;
      }
      formatDateTime =
        Y + "年" + M + "月" + D + "日 " + H + ":" + Min + ":" + S + " 星期" + W;
      return formatDateTime;
    }
  }
};
</script>
<style scoped>
.tablist {
  width: 100%;
  display: flex;
  background-image: url("/static/img/nav-bg1.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  position: relative;
}
.tablist p {
  position: absolute;
  /* top: 16px; */
  top: 30%;
  right: 10px;
  color: #358bff;
}
.tablist div {
  width: 11%;
  margin: 10px 0;
  /* margin-top: 12px;
    margin-bottom: 10px; */
  /* margin-bottom: 0.5vw; */
  color: #358bff;
  /* font-size: 16px; */
  text-align: center;
  border-right: solid 1px #358bff;
  cursor: pointer;
}
.active {
  color: #ffffff !important;
  font-weight: bold;
}
.tablist img {
  width: 1.3vw;
  height: 1.2vw;
  vertical-align: middle;
  padding-bottom: 0.4vw;
}
.tablist span {
  font-size: 1vw;
}
@media screen and (max-width: 1540px) {
}
.njClass {
  display: flex;
}
.njClass li {
  font-size: 0.9vw;
  cursor: pointer;
  color: #439bff;
  padding-left: 2.1vw;
  border-right: solid 1px #358bff;
  margin-top: 0.5vw;
  margin-bottom: 0.5vw;
  margin-right: 0.5vw;
}

.njClass li span {
  font-size: 1vw;
  padding-right: 0.5vw;
}

.njClass li.active {
  color: #ffffff;
}

.njClass li:first-child {
  background: url("/static/img/data_njfb.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:first-child.active {
  background: url("/static/img/data_njfb0.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(2) {
  background: url("/static/img/data_zytj.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(2).active {
  background: url("/static/img/data_zytj0.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(3) {
  background: url("/static/img/data_njtj.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(3).active {
  background: url("/static/img/data_njtj0.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(4) {
  background: url("/static/img/data_kqfw.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(4).active {
  background: url("/static/img/data_kqfw0.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(5) {
  background: url("/static/img/data_njyj.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}

.njClass li:nth-child(5).active {
  background: url("/static/img/data_njyj0.png") no-repeat 10% center;
  background-size: 1.3vw 1.2vw;
}
</style>



// WEBPACK FOOTER //
// src/components/MachineryDistribution/MachineryNav.vue